import { useRef } from 'react';

// Scroll-triggered reveals disabled — always return inView=true so content
// renders immediately without entry animations.
export function useInView(_threshold?: number | { threshold?: number; rootMargin?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  return { ref, inView: true };
}
